app.service('historyService', [ 'sessionStorageService',
  function (sessionStorageService) {
    const service = this;
    const SESSION_STORAGE_KEY = '$visited_history';

    // List of URLs to ignore adding to the history list
    const IGNORE_LIST = [
      '/login/#/Login'
    ];

    /***
     * Adds a URL and page title to the visited history array
     * @param url
     * The URL to add to the list
     *
     * @param title
     * The page title to add to list (for breadcrumbs)
     */
    service.add_to_history = function (url, title) {
      let ignoreEntry = false;
      IGNORE_LIST.forEach(function (elem) {
        if (url.toLowerCase().indexOf(elem.toLowerCase()) !== -1) {
          ignoreEntry = true;
        }
      });

      if (ignoreEntry) {
        return false;
      }

      let visitedHistory = sessionStorageService.get_item(SESSION_STORAGE_KEY);
      if (!visitedHistory) {
        visitedHistory = [];
      }

      // Check if the latest page visited is the same as this one, then don't push it in
      if (visitedHistory.length > 0 && visitedHistory[visitedHistory.length - 1].url === url) {
        return true;
      }

      visitedHistory.push({
        url: url,
        title: title
      });

      sessionStorageService.set_item(SESSION_STORAGE_KEY, visitedHistory);
      return true;
    };

    /***
     * Searches `recentCount` down in recent history to find if a particular URL was visited
     * specified by the regex of the URL and returns the actual URL (first encountered entry)
     *
     * @param regexUrl
     * The URL to search for in regex form
     *
     * @param recentCount
     * How deep we should search for
     */
    service.fetch_from_recent_history = function (regexUrl, recentCount) {
      const visitedHistory = sessionStorageService.get_item(SESSION_STORAGE_KEY);
      if (visitedHistory == null || visitedHistory.length === 0) {
        return null;
      }

      if (regexUrl == '' || regexUrl == null) {
        return null;
      }

      const re = new RegExp(regexUrl, 'gi');

      let countTo = 0;
      if (recentCount != null && $.isNumeric(recentCount)) {
        countTo = Math.max(0, (visitedHistory.length - recentCount));
      }

      for (let i=(visitedHistory.length-1); i >= countTo; i = i-1) {
        const url = visitedHistory[i].url;
        if (url.match(re)) {
          return visitedHistory[i];
        }
      }

      return null;
    };
  }]
);
